import { render, staticRenderFns } from "./BeefCattleCalfModal.vue?vue&type=template&id=2345e910"
import script from "./BeefCattleCalfModal.vue?vue&type=script&lang=js"
export * from "./BeefCattleCalfModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports